import {
  formatClassNames,
  getDataAttributes,
} from '@wix/editor-elements-common-utils';
import classNames from 'clsx';
import type { FC } from 'react';
import React from 'react';

import semanticClassNames from '../SocialPlayerInstagram.semanticClassNames';
import type { SocialPlayerInstagramProps } from '../SocialPlayerInstagram.types';
import classes from './SocialPlayerInstagram.module.scss';
import { toEmbedUrl } from './SocialPlayerInstagram.utils';

const SocialPlayerInstagram: FC<SocialPlayerInstagramProps> = props => {
  const {
    id,
    className,
    customClassNames = [],
    url,
    description,
    onMouseEnter,
    onMouseLeave,
  } = props;

  return (
    <div
      id={id}
      className={classNames(
        classes.root,
        className,
        formatClassNames(semanticClassNames.root, ...customClassNames),
      )}
      style={{ display: 'flex', minHeight: 'fit-content' }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      {...getDataAttributes(props)}
    >
      {url ? (
        <iframe
          className={classNames(
            classes.iFrame,
            formatClassNames(semanticClassNames.iFrame),
          )}
          title={description}
          src={toEmbedUrl(url)}
          allow="autoplay"
          allowFullScreen={true}
          allowTransparency={true}
          loading="lazy"
        />
      ) : null}
    </div>
  );
};

export default SocialPlayerInstagram;
